import { isPasSession } from 'owa-service/lib/pasSession';

export function getSearchRequestTracking(cvid: string): {
    queryParams: Record<string, string>;
    correlationId?: string;
} {
    return isPasSession() ? { queryParams: {}, correlationId: cvid } : { queryParams: { cvid } };
}

// Optional trailing makePostRequest arguments for PAS callers.
export function getPasSearchRequestArguments(): [
    isAnonymousAllowed?: boolean,
    preferIdpToken?: boolean,
    timeoutMS?: number,
    getPasRequestBody?: (body: string) => string,
] {
    return [undefined, undefined, undefined, getPasSearchRequestBody];
}

export function getPasSearchRequestBody(body: string): string {
    const request: unknown = JSON.parse(body);
    if (!request || typeof request !== 'object' || Array.isArray(request)) {
        throw new Error('PAS search identity requires a JSON request object');
    }

    // 3S query/suggestions correlation fields are not result selectors. Keep them on the wire
    // for tracing and search-session grouping; omit only these top-level fields from identity.
    // EntityRequests, SearchContext, paging, refiners and nested IDs remain unchanged.
    return JSON.stringify({ ...request, Cvid: undefined, LogicalId: undefined });
}
